package pl.michal_cyran.brand_hub.subpages.freelancing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaAndroid
import com.varabyte.kobweb.silk.components.icons.fa.FaChartColumn
import com.varabyte.kobweb.silk.components.icons.fa.FaChartLine
import com.varabyte.kobweb.silk.components.icons.fa.FaCode
import com.varabyte.kobweb.silk.components.icons.fa.FaDatabase
import com.varabyte.kobweb.silk.components.icons.fa.FaDivide
import com.varabyte.kobweb.silk.components.icons.fa.FaGlobe
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H6
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.components.widgets.staggerDelay
import pl.michal_cyran.brand_hub.subpages.dayMathAd.composables.ExerciseCard
import pl.michal_cyran.brand_hub.subpages.dayMathAd.composables.FeaturedExerciseCard
import pl.michal_cyran.brand_hub.subpages.freelancing.composables.StackCard
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun FreelancingStack() {
    ColorMode.current.toSitePalette()

    Column {

        VisibilityAware(modifier = Modifier) { isVisible ->
            Column {
                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 0)
                        .toAttrs()
                ) {
                    Text(
                        "Mój stack"
                    )
                }

                P(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    Text(
                        "Tylko sprawdzone, nowoczesne narzędzia, które gwarantują jakość i bezpieczeństwo Twojego produktu."
                    )
                }
            }
        }


        VisibilityAware(modifier = Modifier) { isVisible ->
            SimpleGrid(
                numColumns(base = 1, md = 4),
                modifier = Modifier.gap(1.5.cssRem)
            ) {
                val stacks = listOf(
                    Triple("Kotlin", @Composable{ FaCode() }, "Główny język programowania"),
                    Triple("Jetpack Compose", @Composable{ FaAndroid() }, "UI dla aplikacji mobilnych, desktopowych i webowych"),
                    Triple("Kobweb", @Composable{ FaGlobe() }, "UI dla natywnych stron internetowych"),
                    Triple("SQL / Room", @Composable{ FaDatabase() }, "Zarządzanie danymi"),
                )

                stacks.forEachIndexed { index, (title, icon, subtitle) ->
                    StackCard(
                        title = title,
                        icon = icon,
                        subtitle = subtitle,
                        modifier = Modifier
                            .revealFadeSlideUpScale(
                                isVisible,
                                delayMs = staggerDelay(index, step = 120),
                                distance = 20.px,
                                fromScale = 0.94
                            )
                    )
                }
            }
        }
    }
}